import { IconButton, Skeleton } from '@mui/material'
import styled from 'styled-components'

interface StyledRightProps {
  $hideHeader?: boolean
}

interface StyledCurlProps {
  content: string
}

export const ContentSide = styled.div<StyledRightProps>`
  max-height: ${(props) =>
    props.$hideHeader ? 'calc(100vh - 40px)' : 'calc(100vh - 140px)'};
  min-width: 377px;
  max-width: 377px;
  padding: 20px 0 20px 12px;
  border-left: 1px solid ${(props) => props.theme.colors.grayBorder};

  @media (max-width: 900px) {
    border-left: none;
    border-top: 1px solid ${(props) => props.theme.colors.grayBorder};
    padding: 18px 0;
    max-width: 100%;
  }
`

export const ContentGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
`

export const ContentBox = styled.div`
  display: flex;
  flex-direction: column;
  background: ${(props) => props.theme.colors.darkGray};
  border-radius: 8px;
  padding: 14px 16px;
  min-height: 100px; /* Define a altura mínima */
  max-height: 100%; /* Permite que cresça até o máximo disponível */
  overflow: auto;
`

export const ContentBoxHeader = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding-bottom: 8px;
`

export const ContentBoxHeaderText = styled.span`
  color: ${(props) => props.theme.colors.white};
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
`

export const ContentBoxBody = styled.div<StyledRightProps>`
  max-height: ${(props) => (props.$hideHeader ? '610px' : '510px')};
  font-size: 12px;
  overflow: auto;
  transition: 0.3s ease;

  @media (max-width: 900px) {
    max-height: calc(100vh - 315px);
  }

  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: ${(props) => props.theme.colors.graySemiDark};
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${(props) => props.theme.colors.gray};
    border-radius: 10px;
    border: 2px solid ${(props) => props.theme.colors.graySemiDark};
  }

  scrollbar-width: thin;
  scrollbar-color: ${(props) => props.theme.colors.gray}
    ${(props) => props.theme.colors.graySemiDark};
`

export const ContentCurlRequest = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 2px;
  font-size: 14px;
  font-weight: 600;
  padding: 8px 0;
`

export const ContentCurlRequestHead = styled.div`
  display: flex;
  gap: 8px;
`
export const ContentCurlRequestBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-left: 34px;
  width: 100%;
`

export const ContentCurlRequestRow = styled.div`
  display: flex;
  gap: 8px;
`

export const ContentCurlRequestCurl = styled.span<StyledCurlProps>`
  color: ${(props) => props.theme.colors.yellow};
  &::before {
    content: '${(props) => props.content}';
  }
`

export const ContentCurlRequestAttribute = styled.span<StyledCurlProps>`
  min-width: 30px;
  width: 65px;
  color: ${(props) => props.theme.colors.purple};
  &::before {
    content: '${(props) => props.content}';
  }
`

export const ContentCurlRequestString = styled.span<StyledCurlProps>`
  color: ${(props) => props.theme.colors.green};
  &::before {
    content: "'${(props) => props.content}'";
  }
`

export const ContentCurlRequestComment = styled.span<StyledCurlProps>`
  color: ${(props) => props.theme.colors.purpleGray};
  &::before {
    content: '${(props) => props.content}';
  }
`

export const ContentBoxBodyPath = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${(props) => props.theme.colors.white};
  font-size: 14px;
  font-weight: 600;
  padding: 8px 0;
  border-bottom: 1px solid ${(props) => props.theme.colors.grayBorder};
  margin-bottom: 8px;

  & > span {
    font-weight: 400;
  }
`

export const ContentBoxBodyTextarea = styled.textarea`
  margin: 0px;
  border: 0px;
  width: 100%;
  white-space: pre-wrap;
  overflow: hidden;
  resize: none;
  padding: 0;
  background: transparent;
  color: ${(props) => props.theme.colors.white};
  font-size: 12px;
  line-height: 1.5;

  &:focus {
    outline: none;
  }
`

export const ButtonCopy = styled(IconButton)`
  && {
    color: ${(props) => props.theme.colors.gray};
    width: 38px;
    height: 38px;
    margin: 10px 0 0 10px;
  }
`

export const ContentBoxFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`

export const StyledSkeleton = styled(Skeleton)`
  && {
    border-radius: 4px;
    background: ${(props) => props.theme.colors.grayLight};
    height: calc(100vh - 315px);
  }
`
